import script from "./DashboardCardComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCardComponent.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCardComponent.vue?vue&type=style&index=0&id=06f8baa6&lang=scss"
import "./DashboardCardComponent.vue?vue&type=style&index=1&id=06f8baa6&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f8baa6"]])

export default __exports__